import { createRepeatActions } from '@sonar-software/xuder';
import { issuesArchivedGetSlice } from './get';
import { PaginationDirection } from '@sonar-software/sonar-ts-types';

const getActions = issuesArchivedGetSlice.asyncActionCreators;

export const { resetGetIssuesArchived } = getActions;

export const { action: requestGetIssuesArchived, repeatAction: requestGetIssuesArchivedAgain } = createRepeatActions(
	getActions.requestGetIssuesArchived,
	{
		count: 20,
		paginationDirection: PaginationDirection.Forward
	}
);
